import { Injectable } from "@angular/core";
import { Resolve, ActivatedRouteSnapshot } from "@angular/router";
import { Observable } from "rxjs";
import {Card} from "../models/card";
import {CardService} from "../services/card.service";

@Injectable()
export class CardResolve implements Resolve<Card> {
    constructor(private cardService: CardService) {}

    resolve(route: ActivatedRouteSnapshot): Observable<Card> {
        return this.cardService.getById(route.params.cardId);
    }
}